module.exports = __webpack_public_path__ + "static/media/face4.7bca4587.jpg";